import ExtractPDFContent from "../../../../src/pages/apis/pdf-services/extract-pdf-content.md";
import CreatePDF from "../../../../src/pages/apis/pdf-services/create-pdf.md";
import DocumentGeneration from "../../../../src/pages/apis/pdf-services/document-generation.md";
import ConvertPDF from "../../../../src/pages/apis/pdf-services/convert-pdf.md";
import OcrPDF from "../../../../src/pages/apis/pdf-services/ocr-pdf.md";
import SecurePDF from "../../../../src/pages/apis/pdf-services/secure-pdf.md";
import RemovePDFPassword from "../../../../src/pages/apis/pdf-services/remove-pdf-password.md";
import GetPDFProperties from "../../../../src/pages/apis/pdf-services/get-pdf-properties.md";
import CheckPDFAccessibility from "../../../../src/pages/apis/pdf-services/check-pdf-accessibility.md";
import PDFWatermark from "../../../../src/pages/apis/pdf-services/pdf-watermark.md";
import SplitPDF from "../../../../src/pages/apis/pdf-services/split-pdf.md";
import CombinePDF from "../../../../src/pages/apis/pdf-services/combine-pdf.md";
import CompressPDF from "../../../../src/pages/apis/pdf-services/compress-pdf.md";
import ReorderPDFPages from "../../../../src/pages/apis/pdf-services/reorder-pdf-pages.md";
import LinearizePDF from "../../../../src/pages/apis/pdf-services/linearize-pdf.md";
import InsertPDFPages from "../../../../src/pages/apis/pdf-services/insert-pdf-pages.md";
import ReplacePDFPages from "../../../../src/pages/apis/pdf-services/replace-pdf-pages.md";
import DeletePDFPages from "../../../../src/pages/apis/pdf-services/delete-pdf-pages.md";
import RotatePDFPages from "../../../../src/pages/apis/pdf-services/rotate-pdf-pages.md";
import HTMLToPDF from "../../../../src/pages/apis/pdf-services/html-to-pdf.md";
import AccessibilityAutoTagApi from "../../../../src/pages/apis/pdf-services/accessibility-auto-tag-api.md";
import EsealAPI from "../../../../src/pages/apis/pdf-services/e-seal.md";
import ExportFormData from "../../../../src/pages/apis/pdf-services/export-pdf-form-data.md";
import ImportFormData from "../../../../src/pages/apis/pdf-services/import-pdf-form-data.md";
import "../../../../src/pages/apis/pdf-services/key-features-code-block.css";
import * as React from 'react';
export default {
  ExtractPDFContent,
  CreatePDF,
  DocumentGeneration,
  ConvertPDF,
  OcrPDF,
  SecurePDF,
  RemovePDFPassword,
  GetPDFProperties,
  CheckPDFAccessibility,
  PDFWatermark,
  SplitPDF,
  CombinePDF,
  CompressPDF,
  ReorderPDFPages,
  LinearizePDF,
  InsertPDFPages,
  ReplacePDFPages,
  DeletePDFPages,
  RotatePDFPages,
  HTMLToPDF,
  AccessibilityAutoTagApi,
  EsealAPI,
  ExportFormData,
  ImportFormData,
  React
};